import React from 'react';
import { Outlet } from 'react-router-dom';
import { ConfigProvider, Layout } from 'antd';
import { themeAnt } from '@blink/components';
import { Provider } from 'react-redux';

import { useStyle } from './app.style';
import {
    AuthProvider,
    ProvidersProvider,
    Toaster,
    ModalProvider,
    CentrifugeProvider,
    DataDogProvider,
    MarginAccountsProvider,
    WagmiProviderWrapper,
} from './providers';

import { Layout as LayoutWrapper } from '@/shared/ui';
import { AppHeader } from '@/features/AppHeader';
import { store } from '@/shared/store';
import { Footer } from '@/widgets/Footer';
import { useGetAllFeatureFlags } from '@/shared/hooks/useGetAllFeatureFlags';

import './globals.css';

const { Content } = Layout;

type AppProps = {
    children?: React.ReactNode;
};

const App: React.FC<AppProps> = ({ children }) => {
    const classes = useStyle();

    useGetAllFeatureFlags();

    return (
        <ConfigProvider theme={themeAnt}>
            <Provider store={store}>
                <CentrifugeProvider>
                    <ProvidersProvider>
                        <AuthProvider>
                            <MarginAccountsProvider>
                                <WagmiProviderWrapper>
                                    <DataDogProvider>
                                        <ModalProvider>
                                            <Layout className={classes.layout}>
                                                <Content>
                                                    <Toaster />
                                                    <LayoutWrapper isBorder>
                                                        <AppHeader />
                                                        {children}
                                                    </LayoutWrapper>
                                                    <Outlet />
                                                    <Footer />
                                                </Content>
                                            </Layout>
                                        </ModalProvider>
                                    </DataDogProvider>
                                </WagmiProviderWrapper>
                            </MarginAccountsProvider>
                        </AuthProvider>
                    </ProvidersProvider>
                </CentrifugeProvider>
            </Provider>
        </ConfigProvider>
    );
};

export default App;
